import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './assets/design-system.css'
import './assets/main.css'
import Chart from 'chart.js/auto'
window.Chart = Chart

const app = createApp(App)
app.use(createPinia())
app.mount('#app')
